/**
 * Application settings and configuration values
 * Centralized location for all configurable parameters used across the app
 */

const whatsappConsultationMessage =
  "Halo Admin #PintarPilihKuliah, saya sedang melihat Program Mentoring Beasiswa. Saya ingin bertanya program wilayah mana yang paling sesuai dengan rencana kuliah saya.";

const settings = {
  // WhatsApp related links
  wa_group_link: "https://chat.whatsapp.com/En2xvhNfpgcAkOFLBYnurx",
  wa_consultant_link: "https://wa.me/6285136667008",
  wa_consultant_prefilled_link: `https://wa.me/6285136667008?text=${encodeURIComponent(
    whatsappConsultationMessage,
  )}`,

  // Social media links
  social_media: {
    instagram: "https://instagram.com/pintarpilihkuliah",
    facebook: "https://facebook.com/pintarpilihkuliah",
    youtube: "https://youtube.com/@pintarpilihkuliah",
  },

  // Contact information
  contact: {
    email: "info@pintarpilihkuliah.com",
    phone: "+6285136667008",
  },

  // Application metadata
  app_name: "#PintarPilihKuliah",
  app_description:
    "Platform untuk memudahkan alumni pesantren dan pelajar se-Indonesia untuk mengakses peluang pendidikan internasional.",

  // Feature flags
  features: {
    enable_blog: true,
    enable_testimonials: true,
    enable_wa_floating_button: true,
  },
};

export default settings;
